/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Expand = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12.92 4.02315L12.9733 5.52315H17.36L12.8896 9.99353L13.9503 11.0542L18.4206 6.58382L18.4206 10.9705L19.9206 11.0238L19.9206 5.52315C19.9206 4.69472 19.2491 4.02315 18.4206 4.02315L12.92 4.02315Z"
                        fill={color}
                    />
                    <path
                        d="M10.9814 19.9632L10.9281 18.4632H6.54139L11.0118 13.9928L9.9511 12.9321L5.48074 17.4025L5.48074 13.0158L3.98074 12.9625L3.98074 18.4632C3.98074 19.2916 4.65231 19.9632 5.48074 19.9632L10.9814 19.9632Z"
                        fill={color}
                    />
                </svg>
        );
    };
